/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Plates_OpenInputs */

const en_us2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out the plates`)
};

const pt_br2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular anilhas`)
};

const es_419_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular discos`)
};

const pt_pt2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcular discos`)
};

const fr_fr2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculer les disques`)
};

const de_de2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheiben berechnen`)
};

const it_it2_workout_logging_plates_open = /** @type {(inputs: Workout_Logging_Plates_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola i dischi`)
};

/**
* | output |
* | --- |
* | "Work out the plates" |
*
* @param {Workout_Logging_Plates_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_open = /** @type {((inputs?: Workout_Logging_Plates_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_open(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_open(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_open(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_open(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_open(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_open(inputs)
	return en_us2_workout_logging_plates_open(inputs)
});
export { workout_logging_plates_open as "workout-logging.plates_open" }